import(/* webpackMode: "eager" */ "/var/www/client/node_modules/.pnpm/@picsart+design-system@14.20.0_@lexical+react@0.45.0_react-dom@18.3.1_react@18.3.1__rea_a2b6af87f0139f3df67fbccd7da3bfd0/node_modules/@picsart/design-system/foundation.css");
;
import(/* webpackMode: "eager" */ "/var/www/client/node_modules/.pnpm/next@14.2.33_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/client/node_modules/.pnpm/next@14.2.33_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/client/node_modules/.pnpm/next@14.2.33_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/client/node_modules/.pnpm/next@14.2.33_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/var/www/client/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/client/src/components/AppBanner/AppBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/client/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/client/src/components/GoogleAnalytics/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/client/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/client/src/components/StickyHeader/StickyHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/client/src/providers/index.tsx");
